<template>
    <v-data-table
        :headers="headers"
        dense
        :items="all.items"
        sort-by="id"
        :search="search"
        class="elevation-1"
        @click:row="editItem"
    >
        <template v-slot:top>
            <v-toolbar flat color="yellow">
                <v-toolbar-title>Tramitador</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px" persistent>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            class="mx-2"
                            fab
                            dark
                            x-small
                            color="warning"
                            v-on:click="editItem(null)"
                        >
                            <v-icon dark>mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container grid-list-md>
                                <v-row>
                                    <v-layout wrap>
                                        <v-flex xs12 sm6 md4>
                                            <v-text-field
                                                v-model="item.nombre"
                                                label="Nombre"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm6 md6>
                                            <selectCliente
                                                v-model="item.cliente.id"
                                                :texto="item.cliente.nombre"
                                                @texto="
                                                    item.cliente.nombre = $event
                                                "
                                            >
                                            </selectCliente>
                                        </v-flex>

                                        <v-flex xs12 sm6 md6>
                                            <selectZonainfluencia
                                                v-model="item.zonainfluencia.id"
                                                :texto="
                                                    item.zonainfluencia.nombre
                                                "
                                                @texto="
                                                    item.zonainfluencia.nombre = $event
                                                "
                                            >
                                            </selectZonainfluencia>
                                        </v-flex>

                                        <v-flex xs12 sm6 md6>
                                            <v-text-field
                                                v-model="item.telefono"
                                                label="Teléfono"
                                            >
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm6 md6>
                                            <v-text-field
                                                v-model="item.email"
                                                label="e-mail"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close"
                                >Cancela</v-btn
                            >
                            <v-btn color="blue darken-1" text @click="save"
                                >Guarda</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
            <v-icon small @click="deleteItem(item)">
                delete
            </v-icon>
        </template>
        <template v-slot:no-data>
            <v-btn color="yellow" @click="initialize">Reset</v-btn>
        </template>
    </v-data-table>
</template>

<script>
import selectCliente from '@/components/Selects/selectCliente';
import selectZonainfluencia from '@/components/Selects/selectZonaInfluencia';
import { mapState, mapActions } from 'vuex';
export default {
    name: 'tramitador',
    data() {
        return {
            dialog: false,
            search: '',
            headers: [
                {
                    text: 'Id',
                    align: 'left',
                    sortable: true,
                    value: 'id'
                },
                { text: 'Nombre', value: 'nombre' },
                { text: 'Cliente', value: 'cliente.nombre' },
                { text: 'Zona Influencia', value: 'zonainfluencia.nombre' },
                { text: 'Teléfono', value: 'telefono' },
                { text: 'e-mail', value: 'email' },
                { text: 'Opciones', value: 'action', sortable: false }
            ]
        };
    },

    computed: {
        ...mapState('tramitador', ['all', 'item', 'defaultItem', 'index']),
        formTitle() {
            return this.index === -1 ? 'Nuevo tramitador' : 'Edita tramitador';
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        }
    },

    created() {
        this.initialize();
    },

    methods: {
        ...mapActions('tramitador', [
            'getAll',
            'putObject',
            'postObject',
            'deleteObject',
            'setItem',
            'setIndex'
        ]),

        initialize() {
            this.getAll();
            this.setItem(Object.assign({}, this.defaultItem));
        },

        editItem(itm) {
            if (itm == null) {
                this.setItem(Object.assign({}, this.defaultItem));
                this.setIndex(-1);
            } else {
                var e = this.all.items.findIndex(x => x.id == itm.id);
                this.setIndex(e);
                this.setItem(Object.assign({}, itm));
            }
            this.dialog = true;
        },

        deleteItem(item) {
            const index = this.all.items.indexOf(item);
            if (confirm('Desea borrar el tramitador?')) {
                this.deleteObject(item.id);
                this.all.items.splice(index, 1);
            }
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.setItem(Object.assign({}, this.defaultItem));
                this.setIndex(-1);
            }, 300);
        },

        save() {
            if (this.index > -1) {
                this.putObject(this.item);
                Object.assign(this.all.items[this.index], this.item);
            } else {
                this.postObject(this.item).then(registro => {
                    this.all.items.push(registro);
                });
            }
            this.close();
        }
    },
    components: {
        selectCliente,
        selectZonainfluencia
    }
};
</script>
